export default {
    title: '씨앗글자',

    level: {
        format: '{level}레벨',
        nextLevel: '다음 레벨',
        currentLevel: '현재 레벨',
    },

    session: {
        count: '{count}회',
        exam: '쪽지시험',
        examScore: '{score}점',
        study: '학습',
        completed: '완료',
        locked: '잠금',
        inProgress: '진행 중',
    },

    navigation: {
        toWaitingRoom: '대기실로 이동',
        toStudy: '학습하기',
        toExam: '시험보기',
        continue: '계속하기',
        stop: '중단하기',
    },

    study: {
        start: '시작하기',
        continue: '계속하기',
        complete: '완료',
        stop: '중단하기',
        stopConfirm: '정말로 학습을 중단하시겠습니까?',
        example: '예문',
        meaning: '뜻',
        sound: '소리',
        listen: '소리 듣기',
    },

    exam: {
        start: '시작하기',
        grade: '채점하기',
        result: '결과 보기',
        questions: {
            intro: '문제를 시작합니다',
            upper: '윗글자 문제',
            lower: '아랫글자 문제',
        },
    },

    modal: {
        studyComplete: {
            title: '학습 완료',
            message: '축하합니다! 학습을 완료했습니다.',
        },
        examComplete: {
            title: '시험 완료',
            message: '시험이 완료되었습니다.',
        },
        stopConfirm: {
            title: '학습 중단',
            message: '정말로 학습을 중단하시겠습니까?<br/>진행 상황이 저장되지 않을 수 있습니다.',
        },
    },

    errors: {
        audioPlay: '오디오 재생중 문제가 생겼습니다',
        loadData: '데이터를 불러오는 중 오류가 발생했습니다',
    },
};
